import { InjectionKey } from 'vue';
import { ReferralToCreate } from '@/staff/domain/referral/ReferralToCreate';
import { ClubSlug } from '@/staff/domain/club/ClubSlug';

export const referralRepositoryKey: InjectionKey<ReferralRepository> = Symbol();

export interface ReferralRepository {
  create(clubSlug: ClubSlug, referral: ReferralToCreate): Promise<void>;
}
